<template>
    <div id="app">
        <v-app id="inspire">    
            <v-flex><br><br><br>
                <v-container>
                    <v-stepper v-model="stepper">
                        <v-stepper-header class="blue-grey darken-3">
                            <v-stepper-step color="green darken-2" :complete="stepper > 1" step="1" >
                                <span class="white--text">{{ branch }}</span>
                            </v-stepper-step>

                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 2" step="2">
                                <span class="white--text">Select Motorcycle</span>
                            </v-stepper-step>
                    
                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 3" step="3" >
                                <span class="white--text">Services</span>
                            </v-stepper-step>
                    
                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 4" step="4" >
                                <span class="white--text">Schedule</span>
                            </v-stepper-step>

                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 5" step="5" >
                                <span class="white--text">Review Appointment</span>
                            </v-stepper-step>
                        </v-stepper-header>
                    
                        <v-stepper-items class="grey lighten-5">
                            <v-stepper-content step="2">
                                <v-layout wrap>
                                    <v-container>
                                        <v-flex xs12>
                                            <div v-if="user">
                                                <v-flex xs12 class="pl-3 hidden-md-and-up"> 
                                                    <v-btn v-if="user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                                    <v-btn v-else right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                                                </v-flex>

                                                <v-flex xs12 class="pl-3 hidden-sm-and-down"> 
                                                    <v-btn v-if="user.mobileNumber == ''"  right color="red accent-4" large outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                                    <v-btn v-else right color="red accent-4" large outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-select label="Select your motorcycle" required v-model="mcUnit" prepend-icon="motorcycle" :items="mcOwned"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                                    <v-text-field v-model="oldOdo" label="Last Mileage(km)" required  prepend-icon="timer" readonly></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                                    <v-text-field v-model="odometer" label="Current Mileage(km)" required mask="#######" placeholder="Optional" prepend-icon="timer"></v-text-field>
                                                </v-flex>
                                            </div>

                                            <div v-else>
                                                <v-flex xs12>
                                                    <v-select label="Motorcycle Classification" required :items="masterClassifications" v-model="masterClassification"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-select label="Brand" required :items="masterBrands" v-model="masterBrand" 
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-combobox label="Model" required :items="masterModels" v-model="masterModel"
                                                    ></v-combobox>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="odometer" mask="#######" label="Mileage(km)" placeholder="Optional"></v-text-field>
                                                </v-flex>
                                            </div>

                                            <v-container text-xs-center>
                                                <v-layout class="justify-center">
                                                    <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="goToPage('branch-locator')">Back</v-btn>
                                                    <v-btn v-if="user" color="blue darken-4" class="white--text" @click="mcValidation()"> Next </v-btn>
                                                    <v-btn v-else color="blue darken-4" class="white--text" @click="masterValidation()"> Next </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-container>
                                </v-layout>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.
                                </v-card-title>

                            </v-stepper-content>
                    
                            <v-stepper-content step="3">
                                <!-- LARGE DEVICE -->
                                <v-layout wrap class="hidden-sm-and-down">
                                    <v-flex xs6>
                                        <v-card-title class="justify-center title font-weight-black pb-0 pt-4">SERVICE MENU
                                        </v-card-title>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3">
                                                    <v-card-title class="text-uppercase justify-center subheading font-weight-bold pb-0">{{category}}</v-card-title>

                                                    <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                        <v-checkbox class="pa-0" type="checkbox" :label="service.serviceName" v-model="selected.service" :value="service"/>
                                                        <v-card-title class="caption font-weight-regular pt-0">{{service.description}}
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    
                                    <v-flex xs6 class ="pt-3">
                                        <v-container grid-list-sm fluid>
                                            <v-layout v-for="(list,index) in otherServices" :key="index">
                                                <v-flex xs12>
                                                    <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required
                                                    append-outer-icon="cancel" @click:append-outer="removeOtherService(index)"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex xs12 class="pl-0">
                                                <v-btn outline dark color="red accent-4" @click="addOtherServices()">Add Other Services</v-btn>
                                            </v-flex>
                                        </v-container>

                                        <v-container text-xs-center>
                                            <v-layout class="justify-center">
                                                <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="stepper=2">Back</v-btn>
                                                    <v-btn color="blue darken-4" class="white--text" @click="(serviceValidation(),setServices(),chargeEstimate())"> Next </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-layout>

                                <!-- SMALL DEVICE -->
                                <v-layout wrap class="hidden-md-and-up">
                                    <v-flex xs12>
                                        <v-card-title class="justify-center title font-weight-bold pb-0 pt-4">SERVICE MENU
                                        </v-card-title>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3">
                                                    <v-card-title class="text-uppercase justify-center subheading font-weight-bold pb-0">{{category}}</v-card-title>

                                                    <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                        <v-checkbox class="pa-0" type="checkbox" :label="service.serviceName" v-model="selected.service" :value="service"/>
                                                        <v-card-title class="caption font-weight-regular pt-0">{{service.description}}
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    
                                    <v-flex xs12 class ="pt-3">
                                        <v-container grid-list-sm fluid>
                                            <v-layout v-for="(list,index) in otherServices" :key="index">
                                                <v-flex xs12>
                                                    <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required
                                                    append-outer-icon="cancel" @click:append-outer="removeOtherService(index)"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex xs12 class="pl-0">
                                                <v-btn outline dark color="red accent-4" @click="addOtherServices()">Add Other Services</v-btn>
                                            </v-flex>
                                        </v-container>

                                        <v-container text-xs-center>
                                            <v-layout class="justify-center">
                                                <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="stepper=2">Back</v-btn>
                                                    <v-btn color="blue darken-4" class="white--text" @click="(serviceValidation(),setServices(),chargeEstimate())"> Next </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-layout>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.
                                </v-card-title>
                            </v-stepper-content>

                            <v-stepper-content step="4">
                                <v-container>
                                    <!-- LARGE DEVICES  -->
                                    <v-layout class="hidden-sm-and-down">
                                        <v-flex xs7>
                                            <div>
                                                <v-date-picker v-model="calendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" event-color="red">
                                                </v-date-picker>
                                            </div><br>
                                            
                                            <v-layout justify-center>
                                                <v-btn color="grey darken-1" class="white--text" @click="stepper=3">Back</v-btn>
                                                <v-btn color="blue darken-4" class="white--text" @click="(scheduleValidation(),timeUpdate())"> Next </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs5>
                                            <v-container grid-list-md text-xs-center>
                                                <v-layout row wrap v-if="!arrayEvents.includes(calendar)">
                                                    <v-flex xs12>
                                                        <v-select v-model="mechanic" :items="mechanics" label="Select Mechanic*" hide-details></v-select>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-2">PM 
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>

                                    <!-- SMALL DEVICES  -->
                                    <v-layout row wrap class="hidden-md-and-up">
                                        <v-flex xs12>
                                            <div>
                                                <v-date-picker v-model="calendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" event-color="red">
                                                </v-date-picker>
                                            </div><br>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-container grid-list-md text-xs-center>
                                                <v-layout row wrap v-if="!arrayEvents.includes(calendar)">
                                                    <v-flex xs12>
                                                        <v-select v-model="mechanic" :items="mechanics" label="Select Mechanic*" hide-details></v-select>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                                        </v-card-title>

                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-2">PM 
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                </v-layout>
                                            </v-container>
                                        </v-flex>

                                        <v-layout justify-center>
                                            <v-btn color="grey darken-1" class="white--text" @click="stepper=3">Back</v-btn>
                                            <v-btn color="blue darken-4" class="white--text" @click="(scheduleValidation(),timeUpdate())"> Next </v-btn>
                                        </v-layout>
                                    </v-layout>
                                </v-container>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: Please arrive at least 15 minutes before the appointment schedule to avoid booking cancellation.
                                </v-card-title>
                            </v-stepper-content>

                            <v-stepper-content step="5">
                                <v-flex xs12 md12 lg12>
                                    <v-card-title class="justify-center display-1 font-weight-black">APPOINTMENT SUMMARY
                                    </v-card-title>
                                </v-flex>

                                <v-container>
                                    <v-layout wrap>
                                        <v-flex xs12 md6 lg6 v-if="Scheduler.appointment">
                                            <v-card-title class="subtitle-2 font-weight-black pb-2"> 
                                                Work Requested
                                            </v-card-title>
                                            
                                            <v-card-title v-for="card in Scheduler.appointment.initialService" :key="card.id" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.displayName}}
                                            </v-card-title>

                                            <v-card-title v-for="(card,index) in Scheduler.appointment.otherService" :key="index" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.service}}
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs12 md6 lg6 v-else>
                                            <v-card-title class="subtitle-2 font-weight-black pb-2"> 
                                                Work Requested
                                            </v-card-title>
                                            
                                            <v-card-title v-for="card in initialService" :key="card.id" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.displayName}}
                                            </v-card-title>

                                            <v-card-title v-for="(card,index) in otherServices" :key="index" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.service}}
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs12 md6 lg6 v-if="Scheduler.appointment">
                                            <v-card-title v-if="user" class="subtitle-2 font-weight-black pb-0"> 
                                                {{user.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="user" class="subtitle-2 font-weight-bold pb-0 pt-0"> 
                                                {{user.email}} | +63{{user.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.branch}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.formatedDate}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.appointmentTime}}
                                            </v-card-title><br>

                                            <v-divider></v-divider>
                                        </v-flex>
                                        
                                        <v-flex xs12 md6 lg6 v-else>
                                            <v-card-title v-if="user" class="subtitle-2 font-weight-black pb-0"> 
                                                {{user.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="user" class="subtitle-2 font-weight-bold pb-0 pt-0"> 
                                                {{user.email}} | +63{{user.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{branch}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{computedDateFormattedMomentjs}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{schedtime}}
                                            </v-card-title><br>

                                            <v-divider></v-divider>
                                        </v-flex>
                                        
                                        <v-layout wrap class="justify-center" v-if="user && !Scheduler.appointment">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn v-if="user.mobileNumber" dark color="blue darken-4" @click="(generateId())"> Save </v-btn>
                                        </v-layout>

                                        <v-layout wrap class="justify-center" v-if="user && Scheduler.appointment">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn v-if="user.mobileNumber && Scheduler.appointment.motorcycleDetails.email != ''" dark color="blue darken-4" @click="(generateId())"> Save </v-btn>
                                            <v-btn v-else-if="!user.mobileNumber" dark color="blue darken-4" @click="openProfileDialog()"> Update Profile </v-btn>
                                            <v-btn v-else-if="Scheduler.appointment.motorcycleDetails.email == '' && user.mobileNumber" dark color="blue darken-4" @click="mcSelectionDialog=true" >Verify</v-btn>
                                        </v-layout>
                                        

                                        <v-layout wrap class="justify-center" v-else-if="!user">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn dark color="blue darken-4" @click="storeDetails()"> Confirm </v-btn>
                                        </v-layout>
                                    </v-layout><br>
                                </v-container>

                                <v-flex xs12>
                                    <v-card-title height=10 class="caption font-weight-regular">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic. Once you click Save, your appointment is still pending for Branch Approval. You will receive notification once approved. Please arrive at least 15 minutes before the appointment schedule to avoid booking cancellation.
                                    </v-card-title>
                                </v-flex>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </v-flex>

            <v-dialog v-model="cancelDialog" max-width="500px">
                <v-card>
                    <v-card-title class="title font-weight-regular">
                        Alert
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-title class="subheading font-weight-regular justify-center">
                        Are you sure you want to cancel application ? 
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                        <v-btn color="grey darken-1" dark @click="cancelDialog=false">NO</v-btn>
                        <v-btn color="blue darken-4" dark @click="cancelAppointment()">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="mcSelectionDialog" persistent max-width="600px">
                <v-card>
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12 class="pl-3 hidden-md-and-up"> 
                                <v-btn v-if="user && user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                <v-btn v-else-if="user && user.mobileNumber != ''" right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                            </v-flex>

                            <v-flex xs12 class="pl-3 hidden-sm-and-down"> 
                                <v-btn v-if="user && user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                <v-btn v-else-if="user && user.mobileNumber != ''" right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                            </v-flex>

                            <v-flex xs12>
                                <v-select label="Select your motorcycle" required v-model="mcUnit" prepend-icon="motorcycle" :items="mcOwned"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                <v-text-field v-model="oldOdo" label="Last Mileage(km)" required  prepend-icon="timer" readonly></v-text-field>
                            </v-flex>

                            <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                <v-text-field v-model="odometer" mask="#######" label="Current Mileage(km)" required  prepend-icon="timer"></v-text-field>
                            </v-flex>

                            <v-container text-xs-center>
                                <v-layout class="justify-center">
                                    <v-flex xs12>
                                    <v-btn color="grey darken-1" class="white--text" @click="mcSelectionDialog=false">Back</v-btn>
                                    <v-btn color="blue darken-4" class="white--text" @click="mcVerified()"> Next </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>

            <profileComponent v-model="profileComponent.show" />
            <motorcycleComponent v-model="motorcycleComponent.show" />
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>
</template>

<script>
import Progress from './Progress.vue'
import Snackbar from './Snackbar.vue'
import loginComponent from './Login.vue'
import profileComponent from './Profile.vue'
import motorcycleComponent from './Motorcycle.vue'
import {db} from '../main'
import { mapGetters, mapState } from "vuex"
import { setTimeout } from 'timers'
import _ from 'lodash'
import moment from 'moment'
export default {
    components: {
        loginComponent,
        profileComponent,
        motorcycleComponent,
        Snackbar,
        Progress
    },
    data() {
        return {
            branch: this.$route.params.branch,
            branchCode: this.$route.params.branchCode,
            branchId: this.$route.params.id,
            stepper: this.$route.params.step,
            timeout: 2000,
            allowedDates: null,
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            maximumDate: moment().add(3, 'months').toISOString().substr(0, 10),
            headers: [
                { text: '', align: 'left', sortable: false,  value: '', width: '1%'},
                { text: 'Items for checking', align: 'left', sortable: false,  value: 'name'},
                { sortable: false, align: 'center', text: '', value: ''},
                { sortable: false, align: 'center', text: 'Estimated Price', value: 'price' },
            ],
            services: [],
            estimateCharge: 0,
            chargeHolder: [],
            timeHolder: [],
            estimateTime: 0,
            selected: { service: []},
            cancelDialog: false,
            calendar: moment().utcOffset('+0800').toISOString().substr(0, 10),
            times: [],
            timeDialog: false,
            schedtime: null,
            initialService: [],
            id: 0,
            removed: [],
            showServices: false,
            showCoupon: false,
            coupon: "",
            lists: [],
            laps: [],
            timeValidation: [],
            timeValidation2: [],
            timeRemoveHolder: [],
            timesChecker: [],
            arrayEvents: [],
            odometer: "",
            dateOfPurchase: null,
            dateOfPurchaseMenu: false,
            registrationDate: null,
            registrationDateMenu: false,
            oldOdo: "",
            mcOwned: [],
            mcLists: [],
            mcUnit: "",
            newMcProfileDialog: false,
            mcColor: "",
            dealer: "",
            make: "",
            model: "",
            yearModel: null,
            yearModelMenu: false,
            engineNumber: "",
            chassisNumber: "",
            dealers: [],
            brands: [],
            currentOdo: [],
            branchMechanics: [],
            mechanics: [],
            mechanic: "",
            otherServices: [{
                service: "",
                price: 0,
                time: 0,
            }],
            plateNumber: "",
            timeObtain: [],
            transactions: [],
            selectedMc: null,
            bufferTime: 0,
            classifications: [],
            classification: "",
            serviceMenu: [],
            timepast: moment().format('YYYY-MM-DD, hh:mm a'),
            serviceCategory: [
                "Tune Up",
                "Carburator & Fuel Injection System",
                "Top Overhauling",
                "Major Overhauling",
                "Side Overhauling",
                "Oil Seals",
                "Brake System",
                "Steering System",
                "Cables",
                "Drive Chain & V-Belt",
                "Front and Rear Wheel",
                "Electrical Wiring",
                "Other Services"
            ],
            materialMaster: [],
            masterClassifications: [
                'CUB',
                'Automatic',
                'Business',
                'Hi-End',
            ],
            masterClassification: "",
            masterBrands: [],
            masterBrand: "",
            masterModels: [],
            masterModel: "",
            updateInfoDialog: false,
            mcSelectionDialog: false,
            eventTimes: [],
            profileComponent: {
                show: false,
            },
            motorcycleComponent: {
                show: false,
            },
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
            progress: {
                message: "",
                show: false,
            },
        }
    },

    methods : {
        async fetchTimeSchedule(){
            let self = this
            let count = 0
            self.timesChecker = []
            await db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.timesChecker.push(doc.data().time)
                    count ++

                    if (count === querySnapshot.docs.length) {
                        self.timesChecker.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB);
                        })
                    }
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        async fetchBufferTime() {
            let self = this
            self.showProgress("Loading Buffer...")
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.showSnackbarMessage("Buffer time should be set", false)
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).then(function() {
                self.stopProgress()
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Buffer time should be set", false)
            })
        },

        async fetchMechanics() {
            let self = this
            let mechanics = []
            let scheduleMechanics = []
            self.showProgress("Loading Mechanics...")
            await db.collection("Mechanics"+self.$stage).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    if(doc.data().status === "Active") {
                        mechanics.push(doc.data())
                    }
                })
            }).then(function(){
                if (mechanics) {
                    mechanics.forEach(function(res) {
                        if(res.branch === self.branch) {
                            self.branchMechanics.push(res)
                        }
                    })
                }
            }).then(function() {
                if (self.branchMechanics) {
                    self.branchMechanics.forEach(function(res) {
                        if (res.tag === true) {
                            scheduleMechanics.push(res)
                        }
                    })
                }
            }).then(function() {
                let countMechanic = 0
                if (scheduleMechanics) {
                    scheduleMechanics.forEach(function(res) {
                        self.mechanics.push(res.name)
                        countMechanic ++
                    })
                    if (countMechanic === scheduleMechanics.length) {
                        self.checkMechanics("")
                    }
                }
            }).then(function(){
                if (self.mechanics.length === 1) {
                    self.mechanic = self.mechanics[0]
                }
            }).then(function() {
                self.stopProgress()
            })
        },

        chargeEstimate() {
            let self = this
            self.chargeHolder = []
            self.timeHolder = []
            self.initialService = []

            if (self.selectedMc.classification) {
                self.selected.service.forEach(function (result) {
                    result.classifications.forEach(function(data){
                        if (data.class === self.selectedMc.classification) {
                            self.timeHolder.push(Number(data.time))
                            self.initialService.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                        }
                    })
                })

                self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b }, 0))
                self.estimateCharge =  (self.chargeHolder.reduce(function(a, b) { return a + b }, 0))
                let nf = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'Php',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                nf.format(self.estimateCharge)
                self.estimateCharge = nf.format(self.estimateCharge)
            }
        },

        timeUpdate() {
            let self = this
            self.removed = []
            let index = []
            let index2 = []
            
            if (self.timeValidation.appointmentTime != "" && self.timeValidation.appointmentTime != null) { 
                index = self.times.indexOf(self.timeValidation.appointmentTime)
                self.removed = self.times.splice(index, self.timeValidation.blockTime)
                console.log(index)
            }

            if (self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null) { 
                index2 = self.times.indexOf(self.timeValidation2.appointmentTime)
                self.removed = self.times.splice(index2, self.timeValidation2.blockTime)
                console.log(index2)
                console.log(self.removed)
            }
        },

        async setServiceAppointment(){
            let self = this
            self.timeObtain = []
            await db.collection("ServiceBooking"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("appointmentDate","==",self.calendar)
                .where("status","==","Waiting")
                .where("mechanic","==",self.mechanic)
                .get().then(function(querySnapshot) {
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach(function(res) {
                            res.data().timeHold.forEach(function(data) {
                                self.timeObtain.push(data)
                            })
                        })
                    }
                }).then(async function() {
                    if (self.timeObtain.includes(self.schedtime)) {
                        self.stopProgress()
                        self.showSnackbarMessage("Time already obtain just now. Please select a new time.", false)
                        setTimeout(() => {
                            self.reload()
                        }, 1000)
                    } else {
                        let payload = null
                        if (self.Scheduler.appointment) {
                            payload = {
                                "motorcycleDetails": self.Scheduler.appointment.motorcycleDetails,
                                "userDetails": self.user,
                                "transactionId": self.id.toString(),
                                "appointmentDate": self.Scheduler.appointment.appointmentDate,
                                "appointmentTime": self.Scheduler.appointment.appointmentTime,
                                "branch": self.branch,
                                "branchCode": self.branchCode,
                                "branchId": self.branchId,
                                "initialService": self.Scheduler.appointment.initialService,
                                "otherService": self.Scheduler.appointment.otherService,
                                "estimateCharge": 0,
                                "status": "ForApproval",
                                "estimateTime": self.Scheduler.appointment.estimateTime,
                                "formatedDate": self.Scheduler.appointment.formatedDate,
                                "timeHold": self.Scheduler.appointment.timeHold,
                                "tag": "No Show",
                                "coupon": "",
                                "fee": 0,
                                "customerType": "Self-Service",
                                "lastOdo": "",
                                "odometer": self.Scheduler.appointment.motorcycleDetails.odometer,
                                "mechanic": self.Scheduler.appointment.mechanic,
                                "serving": "0",
                                "remarks": "",
                                "jobType": [],
                                "dateCreated": moment().format('MMMM Do YYYY, h:mm:ss a'),
                                "dateModified": "",
                                "dateApproval": "",
                                "timein": "",
                                "timeout": ""
                            }
                        } else {
                            payload = {
                                "motorcycleDetails": self.selectedMc,
                                "userDetails": self.user,
                                "transactionId": self.id.toString(),
                                "appointmentDate": self.calendar,
                                "appointmentTime": self.schedtime,
                                "branch": self.branch,
                                "branchCode": self.branchCode,
                                "branchId": self.branchId,
                                "initialService": self.initialService,
                                "otherService": self.otherServices,
                                "estimateCharge": self.estimateCharge,
                                "status": "ForApproval",
                                "estimateTime": self.estimateTime,
                                "formatedDate": self.computedDateFormattedMomentjs,
                                "timeHold": self.removed,
                                "tag": "No Show",
                                "coupon": self.coupon,
                                "fee": 0,
                                "customerType": "Self-Service",
                                "lastOdo": self.oldOdo,
                                "odometer": self.odometer,
                                "mechanic": self.mechanic,
                                "serving": "0",
                                "remarks": "",
                                "jobType": [],
                                "dateCreated": moment().format('MMMM Do YYYY, h:mm:ss a'),
                                "dateModified": "",
                                "dateApproval": "",
                                "timein": "",
                                "timeout": ""
                            }
                        }
                        await db.collection("ServiceBooking"+self.$stage).doc(self.id.toString()).set(payload)
                        .then(function(doc) {
                            self.notifications()
                            self.showSnackbarMessage("Appointment saved", true)
                            self.stopProgress()
                            setTimeout(() => {
                                localStorage.removeItem("redirect")
                                self.$store.dispatch("setAppointment", null)
                                self.goToPage("transactions")
                            }, 2000)
                        })   
                    }
                })

        },

        async generateId() {
            let self = this
            let list = []
            let splitSeries = null
            let splitYear = null
            let yearSeries = moment().year()
            let strId = "SS-"
            let pad = "00000"
            let getIndex = null
            let str = null
            let ctrlSeries = null
            self.showProgress("Saving Appointment...") 

        //     await db.collection("ServiceBooking"+self.$stage).orderBy("transactionId", "desc").limit(1)
        // .get().then(function(querySnapshot) {
        //     querySnapshot.forEach(function(doc){
        //         console.log(doc.data())
        //     })
        // })
            
            await db.collection("ServiceBooking"+self.$stage).orderBy("transactionId", "desc").limit(1)
            .get().then(async function(snapshot) {
                snapshot.forEach(function(doc) {
                    list.push(doc.id)
                })

                if(list.length < 1) {
                    self.id =  strId + yearSeries + "-" + "00001"
                } else {
                    list.sort(function(a, b){return a-b})
                    splitYear = _.last(list).split("-")[1]

                    if(yearSeries == splitYear) {
                        if(list.length > 0) {
                            getIndex = _.last(list).split("-")[2]
                        } else {
                            getIndex = (Number(list.length - 1) + 1)
                        }
                        str = "" + (Number(getIndex) + 1)
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                        
                    } else {
                        str = "" + 1
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                    }
                }
                await self.setServiceAppointment()   
            })
        },

        goToPage(page) {
            this.$router.push("/"+page)
        },

        mcValidation() {
            let self = this

            if(self.mcUnit === null || self.mcUnit === "") {
                self.showSnackbarMessage("Please select motorcycle", false)
            } else {
                self.stepper = 3
            } 
        },

        masterValidation() {
            let self = this

            if((self.masterClassification === "" || self.masterClassification === null) || (self.masterBrand === "" || self.masterBrand === null) || (self.masterModel === "" || self.masterModel === null)) {
                self.showSnackbarMessage("Please input your motorcycle details", false)
            } else {
                self.stepper = 3
                self.selectedMc = {
                    chassisNumber:"",
                    classification: self.masterClassification,
                    color:"",
                    dateOfPurchase:null,
                    dealer:"",
                    email:"",
                    engineNumber:"",
                    id: "",
                    make: self.masterBrand,
                    mobile:"",
                    model: self.masterModel,
                    odometer:"0",
                    owner:"",
                    plateNumber:"",
                    registrationDate:null,
                    status:"1",
                    transactions:[],
                    yearModel:null
                }
            } 
        },

        serviceValidation() {
            let self = this
            
            if(self.estimateTime < 1) {
                self.showSnackbarMessage("Please select a service", false)
            } else if (self.estimateTime >= 375) {
                self.showSnackbarMessage("Cannot accomodate too many services.", false)
            } else {
                self.stepper = 4
                self.timepast = moment().format('YYYY-MM-DD, hh:mm a')
            }
        },

        scheduleValidation() {
            let self = this
            if(self.schedtime == null || self.schedtime == "") {
                self.showSnackbarMessage("Please select a time", false)
            } 
            else {
                self.stepper = 5
            }
        },

        setServices(){
            let self = this
            if(self.initialService.length > 0){
                self.showServices = true
            }
        },

        reload() {
            window.location.reload()
        },

        notifications() {
            let self = this
            let source = ""
            let emailMessageToBranch = ""
            let branchUsers = []
            let footer = "Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.".italics()

            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (self.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }
            
            let messagetoBranch = ""
            let smsToBranch = ""

            if (self.Scheduler.appointment) {
                messagetoBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.Scheduler.appointment.formatedDate +" at "+ self.Scheduler.appointment.appointmentTime +" with control number " + self.id +". \n\n" + "Please go to the" +" service request".link(self.$branchUrl +'/service-approval') + " for your approval."+"\n"+ "Your Approval is required." +"\n\n" + "Thank you."
                emailMessageToBranch = messagetoBranch.replace(/(\r\n|\n|\r)/gm, "<br>")

                smsToBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.Scheduler.appointment.formatedDate +" at "+ self.Scheduler.appointment.appointmentTime +" with control number " + self.id +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."
            } else {
                messagetoBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Please go to the" +" service request".link(self.$branchUrl +'/service-approval') + " for your approval."+"\n"+ "Your Approval is required." +"\n\n" + "Thank you."
                emailMessageToBranch = messagetoBranch.replace(/(\r\n|\n|\r)/gm, "<br>")

                smsToBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."
            }

            db.collection("branchUsers"+self.$stage).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    branchUsers.push(doc.data())
                })
            }).then(function() {
                branchUsers.forEach(function(data) {
                    if(data.branch == self.branch) {
                        let mailerBody = {
                            "receiver" : data.email,
                            "subject" : "Customer Appointment Pending for Approval",
                            "html" : emailMessageToBranch
                        }

                        let smsBody = {
                            "source": source,
                            "destination": self.user.countryCode + data.mobileNumber,
                            "text": smsToBranch,
                        }

                        self.$axios.post(self.$smsUrl, smsBody).then(function(){}).catch(error => console.log(error))
                        self.$axios.post(self.$mailerUrl, mailerBody).then(function(){}).catch(error => console.log(error))
                    }
                })
            })
        },

        async calendarValidation() {
            let self = this
            let getEvents = []
            let getLoad = []
            let totalTimeHold = []
            let pivot = null
            let adminTimeProcess = 0

            self.showProgress("Loading Event...")
            await db.collection("Events"+self.$stage)
            .where("branchId","==", self.branchId)
            .where("status","==","approved")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                    adminTimeProcess ++
                })

                self.lists.forEach(function(res) {
                    if (res.timeHold.length > 24) {
                        getEvents.push(res.date)
                        self.arrayEvents.push(res.date)
                    }
                })
                if(adminTimeProcess === self.lists.length) {
                    self.lists.forEach(function(result) {
                        if(result.date == self.calendar) {
                            self.eventTimes=result.timeHold
                        }
                    })
                    // try {
                    //     console.log(self.eventTimes, val)
                    //     if( self.calendar != ""){
                    //         self.times = self.times.filter(value => !self.eventTimes.includes(value))
                    //     }
                    // } catch(err) {}
                }
            }).then(async function(){
                self.stopProgress()
                self.showProgress("Loading Schedule...")
                await db.collection("ServiceBooking"+self.$stage)
                .where("branchId","==", self.branchId)
                .where("status","==","Waiting")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        getLoad.push(doc.data())
                    })

                    console.log(getLoad.length)
                    if (getLoad) {
                        pivot = _(getLoad).groupBy('appointmentDate')
                        .map((item, key) => ({
                            appointmentDate: key,
                            timeHold: _.map(item, 'timeHold'),
                            totalTimeHold: _.sumBy(_.map(item, 'timeHold.length'))
                        })).value()

                        pivot.forEach(function(data) {
                            if(data.totalTimeHold > 24) {
                                getEvents.push(data.appointmentDate)
                                self.arrayEvents.push(data.appointmentDate)
                            }
                        })
                    }
                }).then(function(){
                    self.allowedDates = val =>
                    ![0].includes(new Date(val).getDay())&&!getEvents.includes(new Date(val).toISOString().substr(0, 10),)
                    self.stopProgress()
                })
            })
        },

        async fetchServiceMenu() {
            let self = this
            let services = []
            self.serviceMenu = []   

            self.showProgress("Loading Service Menu...")
            await db.collection("ServiceMenu"+self.$stage)
            .where("status","==","active")
            .get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.serviceMenu.push(doc.data())
                    // if (doc.data().status == "active") {
                    //     self.serviceMenu.push(doc.data())
                    // }
                })
            }).then(function(){
                self.serviceMenu.sort()
                self.stopProgress()
            }).catch(function(error){
                self.stopProgress()
                self.showSnackbarMessage("Error fetching document", false)
            })
        },

        async fetchMotorcycleDetails() {
            let self = this
            self.mcLists = []
            self.mcOwned = []
            await db.collection("McDetails"+self.$stage)
            .where("email","==",self.user.email)
            //.where("owner","==",self.user.fullName)
            .where("status","==","1")
            .get().then(function(querySnapshot){
                if (querySnapshot.docs.length > 0) {
                    querySnapshot.forEach(function(doc){
                        self.mcLists.push(doc.data())
                        self.mcOwned.push(doc.data().model)
                    })
                } 
            }).then(function() {
               // self.mcVerification()
            })
        },

        addOtherServices() {
            let self = this 
            self.otherServices.push({
                service: "",
                price: 0,
                time: 0,
            })
        },

        removeOtherService(index) {
            let self = this 
            self.otherServices.splice(index,1)
        },

        async checkMechanics(val) {
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            self.schedtime = ""
            self.removed = []
            self.timeValidation = []
            self.timeValidation2 = []
            self.laps = []
            self.showProgress("Loading...") 

            if(val) {
                self.schedtime = null
                await db.collection("Mechanics"+self.$stage)
                .where("name","==",val)
                // .where("branchCode","==",self.branchCode)
                .where("branchId","==",self.branchId)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        self.times = doc.data().time
                    })
                }).then(async function() {
                    self.times = self.times.filter(value => !self.eventTimes.includes(value))
                    await db.collection("ServiceBooking"+self.$stage)
                    .where("branchId","==",self.branchId)
                    .where("appointmentDate","==",self.calendar)
                    .where("status","==","Waiting")
                    .where("mechanic","==",val)
                    .get().then(function(querySnapshot) {
                        if (querySnapshot.docs.length > 0) {
                            querySnapshot.forEach(function(doc) {  
                                self.timeValidation.push({
                                    appointmentTime: doc.data().appointmentTime,
                                    blockTime: doc.data().estimateTime / self.bufferTime
                                })
                            })

                            self.timeValidation.forEach(function(val) {
                                index = self.times.indexOf(val.appointmentTime)
                                removedFromDb = self.times.splice(index, val.blockTime)
                                self.laps.push(removedFromDb)
                            })
                            self.stopProgress()
                        } else {
                            self.timeValidation = {
                                appointmentTime: self.schedtime,
                                blockTime: self.estimateTime / self.bufferTime
                            }
                            self.stopProgress()
                        }
                    })
                })
            } else {
                self.stopProgress()
            }
        },

        fetchCategory() {
            let self = this
            self.serviceCategory = []
            
            db.collection("Settings"+self.$stage).doc("Categories")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.serviceCategory.push(doc.data().category)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        cancelAppointment() {
            let self = this
            localStorage.removeItem("redirect")
            self.$store.dispatch("setAppointment", null)
            if (self.$route.params.step == "2") {
                window.location.reload()
            } else {
                self.$router.push(`/service-scheduler/${self.branch}/${self.branchCode}/${self.branchId}/2`)
            }
        },

        async fetchNetsuiteMaterialMaster() {
            let self = this
            self.materialMaster = []
            self.showProgress("Loading MC's...")
            await db.collection("Motorcycles")
            .where("status","==",true)
            .get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.materialMaster.push(doc.data())
                })
            }).then(async function() {
                self.materialMaster = _.uniqBy(self.materialMaster, 'model');
                console.log(self.materialMaster)
                self.stopProgress()
                if (self.user) {
                    await self.fetchMotorcycleDetails()
                }
            }).catch(async function(error) {
                console.error("Error getting document: ", error)
                self.stopProgress()
                if (self.user) {
                    await self.fetchMotorcycleDetails()
                }
            })
        },

        storeDetails() {
            let self = this
            self.selectedMc.odometer = self.odometer
            let payload = {
                "motorcycleDetails": self.selectedMc,
                "appointmentDate": self.calendar,
                "appointmentTime": self.schedtime,
                "branch": self.branch,
                "branchCode": self.branchCode,
                "branchId": self.branchId,
                "initialService": self.initialService,
                "otherService": self.otherServices,
                "status": "ForApproval",
                "estimateTime": self.estimateTime,
                "formatedDate": self.computedDateFormattedMomentjs,
                "timeHold": self.removed,
                "customerType": "Self-Service",
                "lastOdo": "0",
                "odometer": self.odometer,
                "mechanic": self.mechanic,
                "status": "active"
            }
            
            self.$store.dispatch("setAppointment", payload ).then(function() {
                localStorage.setItem("redirect", `${window.location.origin}/service-scheduler/${self.branch}/${self.branchCode}/${self.branchId}/5`);
                console.log(self.Scheduler.appointment)
                self.goToPage('login')
            })
        },

        mcVerification() {
            let self = this
            if (self.mcOwned.includes(self.Scheduler.appointment.motorcycleDetails.model)) {
                self.showSnackbarMessage("Please verify your selected motorcycle to proceed.", false)
            }
        },

        mcVerified() {
            let self = this
            if (self.Scheduler.appointment.motorcycleDetails.model === self.mcUnit) {
                if (self.Scheduler.appointment) {
                    let payload = {
                        "motorcycleDetails": self.selectedMc,
                        "appointmentDate": self.Scheduler.appointment.appointmentDate,
                        "appointmentTime": self.Scheduler.appointment.appointmentTime,
                        "branch": self.Scheduler.appointment.branch,
                        "branchCode": self.Scheduler.appointment.branchCode,
                        "branchId": self.Scheduler.appointment.branchId,
                        "initialService": self.Scheduler.appointment.initialService,
                        "otherService": self.Scheduler.appointment.otherService,
                        "status": "ForApproval",
                        "estimateTime": self.Scheduler.appointment.estimateTime,
                        "formatedDate": self.Scheduler.appointment.formatedDate,
                        "timeHold": self.Scheduler.appointment.timeHold,
                        "customerType": "Self-Service",
                        "lastOdo": "0",
                        "odometer": self.odometer,
                        "mechanic": self.Scheduler.appointment.mechanic,
                        "status": "active"
                    }
                    self.$store.dispatch("setAppointment", payload)
                    self.mcSelectionDialog = false
                }
            } else {
                self.showSnackbarMessage("Please select based on your motorcycle information to proceed.", false)
            }
        },

        openMotorcycleDialog() {
            this.motorcycleComponent.show = true
        },
        closeMotorcycleDialog() {
            this.motorcycleComponent.show = false
        },
        openProfileDialog() {
            this.profileComponent.show = true
        },
        closeProfileDialog() {
            this.profileComponent.show = false
        },
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
    },

    async mounted() {
        let self = this
        await self.closeMotorcycleDialog()
        await self.fetchBufferTime()
        await self.fetchServiceMenu()
        await self.fetchMechanics()
        await self.fetchTimeSchedule()
        await self.calendarValidation()
        await self.fetchNetsuiteMaterialMaster()
        if (self.user) {
            await self.fetchMotorcycleDetails()
        }
        // await db.collection("ServiceBooking"+self.$stage).orderBy("transactionId", "desc").limit(1)
        // .get().then(function(querySnapshot) {
        //     querySnapshot.forEach(function(doc){
        //         console.log(doc.data())
        //     })
        // })
    },

    computed: {
         computedDateFormattedMomentjs () {
                return this.calendar ? moment(this.calendar).format('dddd, MMMM Do YYYY') : ''
            },
        ...mapGetters(["user","appointment"]),
        ...mapState(["Auth","Scheduler"]),
    },

    watch: {
        masterClassification(val) {
            console.log("watch master class")
            let self = this
            self.masterBrands = []
            self.masterModels = []
            self.masterBrand = ""
            self.masterModel = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.masterBrands.push(res.brand)
                    // self.masterModels.push(res.model)
                }
                // self.masterBrands = _.uniqBy(self.masterBrands, 'brand');
            })
        },
        masterBrand(val) {
            console.log("watch master brand")
            let self = this
            self.masterModels = []
            self.masterModel = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.masterClassification) {
                    self.masterModels.push(res.model)
                }
            })
        }, 

        classification(val) {
            console.log("watch class")
            let self = this
            self.masterBrands = []
            self.masterModels = []
            self.make = ""
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.masterBrands.push(res.brand)
                    // self.masterModels.push(res.model)
                }
                // self.masterBrands = _.uniqBy(self.masterBrands, 'brand');
            })
        },
        make(val) {
            console.log("Watch make")
            let self = this
            self.masterModels = []
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.classification) {
                    self.masterModels.push(res.model)
                }
            })
        }, 

        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))

        },
        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        selected: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        mcUnit: function(val) {
            let self = this
            let process = 0

            if(self.mcLists){
                let list = _.filter(self.mcLists, item => item.model === self.mcUnit)
                list.forEach(function(res) {
                    self.oldOdo = res.odometer
                    self.selectedMc = res
                })
            }
            self.odometer = ""
        },

        calendar: async function(val) {
            let self = this
            let adminTime = []
            let adminTimeProcess = 0
            self.eventTimes = []
            self.schedtime = null
            self.times = []

            if (self.mechanics.length === 1) {
                self.mechanic = self.mechanics[0]
            } else {
                self.mechanic = ""
            }

            await db.collection("Events"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("status","==","approved")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        adminTime.push(doc.data())
                        adminTimeProcess ++
                    })
                }).then(function() {
                    if(adminTimeProcess === adminTime.length) {
                        adminTime.forEach(function(res) {
                            if(res.date == self.calendar) {
                                self.eventTimes=res.timeHold
                            }
                        })
                        try {
                            console.log(self.eventTimes, val)
                            if( self.calendar != ""){
                                self.times = self.times.filter(value => !self.eventTimes.includes(value))
                            }
                        } catch(err) {}
                    }
                }).then(async function(){
                    await self.calendarValidation()
                    self.checkMechanics(self.mechanic)
                })
        },

        schedtime: function(val) {
            let self = this
            let index2 = []
            let lapsChecker = []
            self.timeRemoveHolder = []

            self.timeValidation2 = {
                appointmentTime: self.schedtime,
                blockTime: self.estimateTime / self.bufferTime
            }

            if(self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null){      
                index2 = self.timesChecker.indexOf(self.timeValidation2.appointmentTime)
                self.timeRemoveHolder = self.timesChecker.splice(index2, self.timeValidation2.blockTime)
                self.laps = [].concat.apply([], self.laps)

                self.timeRemoveHolder.forEach(function(doc) {
                    if(self.laps.includes(doc)) {
                        lapsChecker.push(doc)
                    }
                })
                
                if(lapsChecker.length > 0) {
                    self.fetchTimeSchedule()
                    self.showSnackbarMessage("Cannot accomodate service in your selected hours. Please select another time", false)
                    setTimeout(() => {
                        index2 = []
                        lapsChecker = []
                        self.timeRemoveHolder = []
                        self.schedtime = null
                    }, 500)
                }
            }
        },
        
        mechanic: function(val) {
            this.checkMechanics(val)
        },
    }
}

</script>

<style scoped>
.transparent {
    background-color: white!important;
    opacity: 1;
    border-color: transparent!important;
}

.background {
    background-image: url('../img/matt-boitor-1390290-unsplash.jpg');
    background-size: 100% 40%;
    background-repeat: no-repeat;
    background-position-x: center;

}
#inspire {
    background: none;
}
</style>
